import { BalanceReportItemImage, BalanceReportItemStateCategory, BalanceReportItemState } from '@square/dashboard-protos/models/squareup/balancereporter/model';
import { momentFromDateTimeWithZone } from '@banking/ui/utils/datetime-converter';
export const VOIDED_STATES = [BalanceReportItemState.DECLINED, BalanceReportItemState.VOIDED];
export function getImage(image) {
  // We add custom styles to the icon container to show the correct background color for icons
  return {
    imageUrl: image.imageUrl,
    styles: `background-color: ${image.backgroundColorCode};`,
    hasDecorationIcon: image.decorationIcon != null,
    isDecorationIconLightningBolt: image.decorationIcon?.icon === BalanceReportItemImage.DecorationIcon.Icon.LIGHTNING_BOLT,
    decorationIconStyles: image.decorationIcon?.backgroundColorCode ? `background-color: ${image.decorationIcon?.backgroundColorCode};` : ''
  };
}
export function fromBalanceReportItem(balanceReportItem) {
  if (!balanceReportItem.amount) {
    throw new Error(`transaction ${balanceReportItem.id} has no amount`);
  }
  if (!balanceReportItem.balance) {
    throw new Error(`transaction ${balanceReportItem.id} has no balance`);
  }
  if (!balanceReportItem.latestEventAt) {
    throw new Error(`transaction ${balanceReportItem.id} has no latestEventAt`);
  }
  if (!balanceReportItem.image) {
    throw new Error(`transaction ${balanceReportItem.id} has no image`);
  }
  const activity = {
    amount: balanceReportItem.amount,
    activities: [],
    availableAt: momentFromDateTimeWithZone(balanceReportItem.latestEventAt).toDate(),
    balance: balanceReportItem.balance,
    createdAt: momentFromDateTimeWithZone(balanceReportItem.latestEventAt).toDate(),
    isInstant: false,
    description: balanceReportItem.description,
    fromAccountName: null,
    id: balanceReportItem.id,
    image: getImage(balanceReportItem.image),
    isAvailable: false,
    isBundle: false,
    isSettled: false,
    isPending: balanceReportItem.stateCategory === BalanceReportItemStateCategory.PENDING,
    isVoided: VOIDED_STATES.includes(balanceReportItem.state),
    settledAt: momentFromDateTimeWithZone(balanceReportItem.latestEventAt).toDate(),
    subtitle: balanceReportItem.description,
    svgModifierClass: '',
    svgName: '24px-square',
    state: balanceReportItem.state,
    title: balanceReportItem.title,
    transactionToken: balanceReportItem.transactionId,
    toAccountName: null,
    traceId: balanceReportItem.id,
    willEarnInterest: false,
    isUnavailableAndEarningInterest: false,
    declineReason: balanceReportItem.declineDetails?.declineReason
  };
  return activity;
}